import CryptoJS from "crypto-js";
import messages from "./PMMessages";
import fieldValue from "./PMFieldName";

export const validEmail = (email) => {
  const regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/;
  return regex.test(String(email).toLowerCase());
};

const validMobileNumber = (phoneNumber) => {
  const regex = /^(\+?)([0-9] ?){9,13}$/;
  return regex.test(Number(phoneNumber));
};

const validPassword = (pass) => {
  const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  //const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[A-Za-z]).{8,}$/;
  return regex.test(String(pass));
};

const validateDOB = (dateOfBirth) => {
  const dateTimestamp = +new Date(dateOfBirth);
  let isValid = true;

  if (isNaN(dateTimestamp)) {
    isValid = false;
  } else {
    const currentDate = +new Date();
    if (dateTimestamp > currentDate) {
      isValid = false;
    }
  }
  return isValid;
};

// check is individual fields are valid
export const validateField = (
  fieldName,
  errorState,
  usersObj,
  isSkipValidation
) => {
  const err = Object.assign(errorState);
  const userObject = { ...usersObj };

  let isFieldValid = userObject[fieldName]
    ? userObject[fieldName].trim().length > 0
    : false;

  switch (fieldName) {
    case fieldValue.FIRSTNAME:
    case fieldValue.LASTNAME:
    case fieldValue.DOCTOR_NAME:
    case fieldValue.CHILD_NAME:
    case fieldValue.RELATIONSHIP:
    case fieldValue.PHYSICIAN_ID:
    case fieldValue.PATIENT_NAME:
    case fieldValue.PATIENT_GENDER:
      err[fieldName] = isFieldValid ? "" : messages(fieldName).required;
      break;
    case fieldValue.CHILD_DOB:
      err[fieldName] = isFieldValid ? "" : messages(fieldName).required;
      if (!err[fieldName]) {
        err[fieldName] = validateDOB(userObject[fieldName])
          ? ""
          : messages(fieldName).invalid;
      }
      break;
    case fieldValue.MOBILE_NUMBER:
      err[fieldName] = isFieldValid ? "" : messages(fieldName).required;
      if (!err[fieldName]) {
        err[fieldName] = validMobileNumber(userObject[fieldName])
          ? ""
          : messages(fieldName).invalid;
      }
      break;
    case fieldValue.EMAIL:
      err[fieldName] = isFieldValid ? "" : messages(fieldName).required;
      if (!err[fieldName]) {
        err[fieldName] = validEmail(userObject[fieldName])
          ? ""
          : messages(fieldName).invalid;
      }
      break;
    case fieldValue.OLD_PASSWORD:
    case fieldValue.PASSWORD:
      err[fieldName] = isFieldValid ? "" : messages(fieldName).required;
      if (!err[fieldName] && !isSkipValidation) {
        err[fieldName] = validPassword(userObject[fieldName])
          ? ""
          : messages(fieldName).invalid;
      }
      break;
    case fieldValue.CONFIRM_PASSWORD:
      err[fieldName] = isFieldValid ? "" : messages(fieldName).required;
      // if (!err[fieldName]) {
      //   err[fieldName] = validPassword(userObject[fieldName])
      //     ? ""
      //     : messages(fieldName).invalid;
      // }
      if (!err[fieldName]) {
        isFieldValid = userObject.confirm_password === userObject.password;
        err[fieldName] = isFieldValid ? "" : messages(fieldName).match;
      }
      break;
    default:
      break;
  }
  return err;
};

export const validateAllFields = (usersObj, isSkipValidation) => {
  let fieldArr = [];
  let errorObj = {};

  fieldArr = Object.keys(usersObj);

  fieldArr.forEach((value, index) => {
    const fieldErrorObj = validateField(
      value,
      errorObj,
      usersObj,
      isSkipValidation
    );
    errorObj = {
      ...errorObj,
      ...fieldErrorObj,
    };
  });
  return errorObj;
};

export const getPasswordHash = (passwordVal) => {
  const hashVal = CryptoJS.MD5(passwordVal);

  return hashVal ? hashVal.toString() : "";
};

export const getUserAccountStatus = () => {
  return {
    ADD_INFO_REQUIRED: "AdditionalInformationRequired",
    WAITING_APPROVAL: "WaitingApproval",
    EMAIL_VERIFICATION_REQUIRED: "EmailVerificationRequired",
    ACTIVE: "Active",
    BLOCKED: "Blocked",
  };
};

export const createLink = (textContent) => {
  let replacePattern1 = "",
    replacePattern2 = "";
  let replacedTextFirst = "",
    replacedText = "";

  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedTextFirst = textContent.replace(
    replacePattern1,
    '<a href="$1" target="_blank">$1</a>'
  );

  replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedTextFirst.replace(
    replacePattern2,
    '$1<a href="http://$2" target="_blank">$2</a>'
  );

  return replacedText;
};

// export const isMobileBrowser = () => {
//   let check = false;
//   (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
//   return check;
// };

// for mobile and tablet
export const isMobileBrowser = () => {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};
